import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
@Injectable({
  providedIn: 'root'
})
export class SparepartsService {

  private datePipe: DatePipe = new DatePipe('zh-cn');
  constructor(public httpClient: HttpClient) { }

  /**
   * 查询库存数据
   * @param param 过滤参数
   * @param pageNum 页码
   * @param pageSize 行数
   */
  async queryStockData(param: any, pageNum: number, pageSize: number) {
    let url = 'plan/api/stock/allData' + '?pageNum=' + pageNum +
      '&pageSize=' + pageSize;
    if (param.spareName == null || param.spareName === undefined || param.spareName === '') {
    } else {
      url = url + '&search=' + param.spareName;
    }
    if (param.typeId == null || param.typeId === undefined || param.typeId === '' || param.typeId === 999) {
    } else {
      url = url + '&typeId=' + param.typeId.toString().replace(',', ' ');
    }
    const ret: any = await this.httpClient.get(url).toPromise();
    return ret;
  }
  /**
   * 删除库存记录
   * @param stNo 库存记录编号
   */
  async deleteStockData(stNo: number) {
    const url = 'plan/api/stock/data';
    const ret: any = await this.httpClient.delete(url, { params: { stNo: [stNo + ''] } }).toPromise();
    // if (ret.code !== 200) {
    //   console.log(ret.msg);
    //   return 0;
    // }
    return ret;
  }
  /**
   * 查询入库单记录信息
   */
  async queryEnrtryData(param: any, pageNum: number, pageSize: number) {
    let url = 'plan/api/entrySpare/entryData' + '?pageNum=' + pageNum +
      '&pageSize=' + pageSize;
    if (param.spareName == null || param.spareName === undefined || param.spareName === '') {
    } else {
      url = url + '&search=' + param.spareName;
    }
    if (param.typeId == null || param.typeId === undefined || param.typeId === 999) {
    } else {
      url = url + '&typeId=' + param.typeId;
    }
    if (param.date == null || param.date === undefined || param.date.length === 0) {
    } else {
      url = url + '&startTime=' + this.datePipe.transform(param.date[0], 'yyyy-MM-dd 00:00:00')
        + '&endTime=' + this.datePipe.transform(param.date[1], 'yyyy-MM-dd 23:59:59');
    }
    if (param.cno == null || param.cno === undefined || param.cno === '') {
    } else {
      url = url + '&cno=' + param.cno;
    }
    const ret: any = await this.httpClient.get(url).toPromise();
    return ret;
  }
  /**
   * 查询出库单信息
   */
  async queryOutData(param: any, pageNum: number, pageSize: number) {
    let url = 'plan/api/outSpare/outData' + '?pageNum=' + pageNum +
      '&pageSize=' + pageSize;
    if (param.spareName == null || param.spareName === undefined || param.spareName === '') {
    } else {
      url = url + '&search=' + param.spareName;
    }
    if (param.typeId == null || param.typeId === undefined || param.typeId === 999) {
    } else {
      url = url + '&typeId=' + param.typeId;
    }
    if (param.date == null || param.date === undefined || param.date.length === 0) {
    } else {
      url = url + '&startTime=' + this.datePipe.transform(param.date[0], 'yyyy-MM-dd 00:00:00')
        + '&endTime=' + this.datePipe.transform(param.date[1], 'yyyy-MM-dd 23:59:59');
    }
    const ret: any = await this.httpClient.get(url).toPromise();
    return ret;
  }
  /**
   * 查询领料单数据
   * @param param 搜索字符串
   * @param pageNum 页码
   * @param pageSize 每页行数
   */
  async queryTakeSparesData(param: any, pageNum: number, pageSize: number) {
    let url = 'plan/api/receiveList/receiveListData' + '?pageNum=' + pageNum +
      '&pageSize=' + pageSize;
    if (param.takeSpareNo == null || param.takeSpareNo === undefined || param.takeSpareNo === '') {
    } else {
      url = url + '&search=' + param.takeSpareNo;
    }
    if (param.typeId == null || param.typeId === undefined || param.typeId === 999) {
    } else {
      url = url + '&typeId=' + param.typeId;
    }
    if (param.date == null || param.date === undefined || param.date.length === 0) {
    } else {
      url = url + '&startTime=' + this.datePipe.transform(param.date[0], 'yyyy-MM-dd 00:00:00')
        + '&endTime=' + this.datePipe.transform(param.date[1], 'yyyy-MM-dd 23:59:59');
    }
    const ret: any = await this.httpClient.get(url).toPromise();
    if (ret.code !== 200) {
      console.log(ret.msg);
      return null;
    }
    return ret.data;
  }
  /**
   * 查询入库/出库类型信息
   * @param type 0表示入库，1表示出库
   */
  async queryEntryOutType(type: number) {
    let url = null;
    if (type === 0) {
      url = 'plan/api/entrySpare/entryType';
    } else {
      url = 'plan/api/outSpare/outType';
    }
    const ret: any = await this.httpClient.get(url).toPromise();
    if (ret.code !== 200) {
      console.log(ret.msg);
      return null;
    }
    return ret.data;
  }
  /**
   * 查询系统用户数据：编号、姓名、电话等
   */
  async queryUserList(value: string) {
    const url = 'plan/api/system/users?value=' + value;
    const ret: any = await this.httpClient.get(url).toPromise();
    if (ret.code !== 200) {
      console.log(ret.msg);
      return null;
    }
    return ret.data;
  }
  /**
   * 查询字典信息
   * @param type 类型
   */
  async queryUnitData(type: string) {
    const url = 'plan/api/dictionary/data?type=' + type;
    const ret: any = await this.httpClient.get(url).toPromise();
    if (ret.code !== 200) {
      console.log(ret.msg);
      return null;
    }
    return ret;
  }
  /**
   * 查询备件列表
   */
  async querySparePartsData(param: any, pageNum: number, pageSize: number) {
    let url = 'plan/api/spareParts/allData' + '?pageNum=' + pageNum +
      '&pageSize=' + pageSize;
    if (param.spareName == null || param.spareName === undefined || param.spareName === '') {
    } else {
      url = url + '&search=' + param.spareName;
    }
    if (param.typeId == null || param.typeId === undefined || param.typeId === '' || param.typeId === 999) {
    } else {
      url = url + '&typeId=' + param.typeId;
    }
    const ret: any = await this.httpClient.get(url).toPromise();
    return ret;
  }
  /**
   * 删除备件信息接口
   */
  async deleteSparePartsData(spNo: any) {
    const url = 'plan/api/spareParts/data';
    const ret: any = await this.httpClient.delete(url, { params: { spNo: [spNo + ''] } }).toPromise();
    return ret;
  }
  /**
   * 修改备件信息
   * @param data 备件信息
   */
  async editSparePartsData(data: any) {
    const url = 'plan/api/spareParts/data';
    const ret: any = await this.httpClient.put(url, data).toPromise();
    return ret;
  }
  /**
   * 新增备件信息
   * @param data 备件信息
   */
  async saveSparePartsData(data: any) {
    const url = 'plan/api/spareParts/data';
    const ret: any = await this.httpClient.post(url, data).toPromise();
    return ret;
  }
  /**
   * 查询指定入库单详情
   * @param weNo 入库单编号
   */
  async queryEntryDetailData(weNo: string) {
    const url = 'plan/api/entrySpare/entryDetailData?weNo=' + weNo;
    const ret: any = await this.httpClient.get(url).toPromise();
    return ret;
  }
  /**
   * 查询指定出库单详情
   * @param weNo 入库单编号
   */
  async queryOutDetailData(woNo: string) {
    const url = 'plan/api/outSpare/outDetailData?woNo=' + woNo;
    const ret: any = await this.httpClient.get(url).toPromise();
    return ret;
  }
  /**
   * 查询领料单详情
   */
  async queryTakeSpareDetailData(takeSpareNo: string) {
    const url = 'plan/api/receiveList/receiveListDetailData?rlNo=' + takeSpareNo;
    const ret: any = await this.httpClient.get(url).toPromise();
    if (ret.code !== 200) {
      console.log(ret.msg);
      return null;
    }
    return ret.data;
  }
  /**
   * 入库单数据保存
   */
  async uploadSparePartsData(enrtyNo: string, typeId: string, deliver: string, cid: string, data: any) {
    const url = 'plan/api/entrySpare/entryData';
    const dataParams = new FormData();
    dataParams.append('entryNo', enrtyNo);
    dataParams.append('typeId', typeId);
    dataParams.append('deliver', deliver);
    dataParams.append('cid', cid == null ? '' : cid);
    dataParams.append('data', JSON.stringify(data));
    const ret: any = await this.httpClient.post(url, dataParams).toPromise();
    if (ret.code !== 200) {
      console.log(ret.msg);
      return null;
    }
    return ret;
  }
  /**
   * 出库单数据保存
   */
  async uploadOutSparePartsData(outNo: string, typeId: string, receiver: string, data: any, outDescription: any, rlNo: any) {
    const url = 'plan/api/outSpare/outData';
    const dataParams = new FormData();
    dataParams.append('outNo', outNo);
    dataParams.append('wotNo', typeId);
    dataParams.append('receiver', receiver);
    dataParams.append('description', outDescription);
    dataParams.append('data', JSON.stringify(data));
    if (rlNo == null || rlNo === undefined) {
    } else {
      dataParams.append('rlNo', rlNo);
    }
    const ret: any = await this.httpClient.post(url, dataParams).toPromise();
    if (ret.code !== 200) {
      console.log(ret.msg);
      return null;
    }
    return ret;
  }
  /**
   * 创建领料单
   */
  async uploadTakeSparePartsData(takeSpareNo: string, missionNo: string, data: any, description: any) {
    const url = 'plan/api/receiveList/receiveListData';
    let ret;
    const dataParams = new FormData();
    dataParams.append('jobNo', missionNo);
    dataParams.append('description', description);
    dataParams.append('data', JSON.stringify(data));
    if (takeSpareNo == null || takeSpareNo === undefined) {
      ret = await this.httpClient.post(url, dataParams).toPromise();
    } else {
      dataParams.append('rlNo', takeSpareNo);
      ret = await this.httpClient.put(url, dataParams).toPromise();
    }
    if (ret.code !== 200) {
      console.log(ret.msg);
    }
    return ret;
  }
  /**
   * 删除入库记录
   * @param stNo 入库记录编号
   */
  async deleteEntryData(stNo: string) {
    const url = 'plan/api/entrySpare/entryData';
    const ret: any = await this.httpClient.delete(url, { params: { weNo: [stNo + ''] } }).toPromise();
    if (ret.code !== 200) {
      console.log(ret.msg);
      return 0;
    }
    return 1;
  }
  /**
   * 删除出库记录
   * @param stNo 出库记录编号
   */
  async deleteOutData(stNo: string) {
    const url = 'plan/api/outSpare/outData';
    const ret: any = await this.httpClient.delete(url, { params: { woNo: [stNo + ''] } }).toPromise();
    if (ret.code !== 200) {
      console.log(ret.msg);
      return 0;
    }
    return 1;
  }
  /**
   * 删除领料单
   * @param rlNo 领料单编号
   */
  async deleteTakeSparesData(rlNo: string) {
    const url = 'plan/api/receiveList/receiveListData';
    const ret: any = await this.httpClient.delete(url, { params: { rlNo: [rlNo] } }).toPromise();
    if (ret.code !== 200) {
      console.log(ret.msg);
      return 0;
    }
    return 1;
  }
  /**
   * 根据备件编号查询库存数据
   * @param spno 备件编号
   */
  async getStockBySpno(spno: string) {
    const result: any = await this.httpClient.get(`plan/api/stock/data/${spno}`).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  /**
   * 备件消耗费用统计（月模式）
   */
  async getSparePartsCostBySkill(
    radioValue: string,
    year?: string,
    month?: string
  ) {
    let url = `plan/api/spareParts/cost`;
    url = url + `?flag=${radioValue}&year=${year}`;
    if (month != null) {
      url = url + `&month=${month}`;
    }
    const result: any = await this.httpClient.get(url).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }



}
